import { Language } from 'providers/translates/enums';
import { TranslatesByLang } from './vac-copy';

const CACHE_KEY = 'vac-translates-v1';

const isPack = (value: unknown): value is Record<string, unknown> =>
  !!value && typeof value === 'object';

export const readVacTranslatesCache = (): TranslatesByLang | null => {
  if (typeof localStorage === 'undefined') {
    return null;
  }

  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (!isPack(parsed?.[Language.ENGLISH]) && !isPack(parsed?.[Language.FRENCH])) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};

export const writeVacTranslatesCache = (byLang: TranslatesByLang) => {
  if (typeof localStorage === 'undefined') {
    return;
  }

  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(byLang));
  } catch {
    /* quota / private mode */
  }
};
